/* eslint-disable */
import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Table from '@material-ui/core/Table'
import Grid from '@material-ui/core/Grid'
import {
  Button,
  InputBase,
  InputAdornment,
  List,
  Typography,
  Tooltip,
  ClickAwayListener,
  Collapse, makeStyles } from '@material-ui/core'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '../../../../static/images/search.svg'
// import Timezone from 'moment-timezone';
import Paper from '@material-ui/core/Paper'

import { EnhancedTableHead } from './components/EnhancedTableHead'
// import { useTranslation } from 'react-i18next';
import Filter from './components/Filter'
import history from 'legacy/containers/History'
// import { ROUTES } from '../../constants/app';
import moment from 'moment'
import { checkTKFeatureEnabled, checkCRPFeatureEnabled } from 'configs'
import { headCells, headCellsNoLicenseOrAvailability, memberFilters } from './data/mockData'
import { useDispatch, useSelector } from 'react-redux'
// import { getAdminSessions } from '../../Store/actions/user';
import EcgLoader from 'legacy/containers/EcgLoader/EcgLoader'
import reactSelectCjsDev from 'react-select/dist/react-select.cjs.dev'
import { FormattedMessage, useIntl } from 'react-intl'

const componentStyle = makeStyles({
  containerStyle: {
    // marginTop: '70px',
  },

  tableRowStyle: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'rgb(250, 250, 250)',
    },
    '&:nth-of-type(even)': {
      backgroundColor: '#fff',
    },
    '&:hover': {
      backgroundColor: '#F0F8F5 !important',
    },
  },
  viewNotesTableColumn: {
    color: 'pink',
    fontWeight: 'bold',
    // fontSize: `${fontSizes.CAPTION} !important`,
    cursor: 'pointer',
  },
  statusColumn: {
    textAlign: 'center',
    borderRadius: '100px',
    letterSpacing: '2.5px',
    fontSize: '10px',
    background: 'white',
    fontWeight: '500',
  },
  yes: {
    border: '2px solid #2D9F86',
    paddingTop: '5px',
    width: '57px',
    height: '25px',
  },
  no: {
    border: '1.5px solid #142A39',
    paddingTop: '5px',
    width: '42px',
    height: '24px',
  },
  expairy: {
    border: '1.5px solid #FDC246',
    paddingTop: '5px',
    width: '137.6px',
    height: '24px',
  },
  active: {
    border: '2px solid #2D9F86',
    paddingTop: '5px',
    width: '90px',
    height: '25px',
  },
  deactivated: {
    border: '1.5px dashed #BABFBD',
    paddingTop: '5px',
    width: '121px',
    height: '25px',
  },
  expired: {
    border: '1.5px solid #CC3D3F',
    paddingTop: '5px',
    width: '90px',
    height: '25px',

  },
  inputElement: {
    borderBottom: '1px solid black',
    width: '90%',
  },
  tableContainer: {
    maxHeight: '60vh',
  },
  searchResultTray: {
    maxHeight: '110px',
    overflow: 'auto',
    position: 'absolute',
    width: 'inherit',
    zIndex: 4,
  },
  searchResultTrayText: {
    fontFamily: 'Work Sans',
    paddingLeft: '24px',
    fontSize: '16px',
    lineHeight: '20px',
    // textOverflow: "ellipsis",
    whiteSpace: 'nowrap',
    // overflow: "hidden",
    width: '30%',
    textTransform: 'capitalize',
  },
  list: {
    '&:hover': {
      backgroundColor: '#E0EFEE !important',
    },
    fontFamily: 'Work Sans !important',
    height: '56px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  searchResultTrayName: {
    fontWeight: 'bold',
  },

})

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [ el, index ])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

function Row({ row, onRowClick, showLicenseAndAvailibility }) {
  const classes = componentStyle()

  const yes = (
    <Box
      width={80}
      height={20}
      className={`${classes.statusColumn} ${classes.yes}`}
    >
      YES
    </Box>
  )
  const No = (
    <Box
      width={80}
      height={20}
      className={`${classes.statusColumn} ${classes.no}`}
    >
      NO
    </Box>
  )
  const expairySoon = (
    <Box
      width={80}
      height={20}
      className={`${classes.statusColumn} ${classes.expairy}`}
    >
      Expiring soon
    </Box>
  )
  const active = (
    <Box
      width={80}
      height={20}
      className={`${classes.statusColumn} ${classes.active}`}
    >
      Active
    </Box>
  )
  const deactivated = (
    <Box
      width={80}
      height={20}
      className={`${classes.statusColumn} ${classes.deactivated}`}
    >
      Deactivated
    </Box>
  )
  const expired = (
    <Box
      width={80}
      height={20}
      className={`${classes.statusColumn} ${classes.expired}`}
    >
     Expired
    </Box>
  )
  const obj = {
    index: row.id,
    row,
  }

  const checkStatus = value => {
    switch (value) {
    case 'Active':
      return active
    case 'Deactivated':
      return deactivated
    case 'Expiring soon':
      return expairySoon
    case 'Expired':
      return expired
    case 'N/A':
      return 'N/A'
    case 'Not Added':
      return 'Not Added'
    case 'None' :
      return 'None'
    default:
      return ''
    }
  }

  if (showLicenseAndAvailibility) {
    return (
      <React.Fragment>
        <TableRow
          hover
          tabIndex={-1}
          key={row.id}
          className={classes.tableRowStyle}
          onClick={e => { onRowClick(obj) }}
          showLicenseAndAvailibility
        >
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '150px', wordBreak: 'break-all' }}>
            {row.lastName},{row.firstName}
          </TableCell>
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '150px', wordBreak: 'break-all' }}>
            {row.email}
          </TableCell>
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '100px', wordBreak: 'break-all' }}>
            {row.role}
          </TableCell>
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '100px', wordBreak: 'break-all' }}>
            {row.availability == 'true' ? yes : row.availability == 'false' ? No : '--'}
          </TableCell>
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '100px', wordBreak: 'break-all' }}>
            {checkStatus(row.status)}
          </TableCell>
        </TableRow>

      </React.Fragment>
    )
  } else {
    return (
      <React.Fragment>
        <TableRow
          hover
          tabIndex={-1}
          key={row.id}
          className={classes.tableRowStyle}
          onClick={e => { onRowClick(obj) }}
          showLicenseAndAvailibility
        >
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '150px', wordBreak: 'break-all' }}>
            {row.lastName},{row.firstName}
          </TableCell>
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '150px', wordBreak: 'break-all' }}>
            {row.email}
          </TableCell>
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '150px', 'textAlign': 'center' }}>
            {row.isAdmin}
          </TableCell>
          <TableCell style={{ fontSize: '14px', fontFamily: 'Work Sans', maxWidth: '150px', 'textAlign': 'center' }}>
            {row.isProvider}
          </TableCell>
        </TableRow>
      </React.Fragment>
    )
  }
}

export default function NewTeamMembers(props) {
  const orderMap = {
    asc: 'ascending',
    desc: 'descending',
  }
  const dispatch = useDispatch()
  const intl = useIntl()
  // const { t } = useTranslation();
  // const timezoneString = useSelector((state) => state.user.team.timezone);
  // const offset = -Timezone.tz(timezoneString).utcOffset();
  const classes = componentStyle()
  const [ order, setOrder ] = useState('asc')
  const [ orderBy, setOrderBy ] = useState('lastName')
  const [ page, setPage ] = useState(0)
  const [ rowsPerPage, setRowsPerPage ] = useState(10)
  const [ tableHeadCells, setTableHeadCells ] = useState([])
  const [ pageCount, setPageCount ] = useState(null)
  const [ open, setOpen ] = useState(false)
  const [ searchResultList, setSearchResultList ] = useState([])

  const [ mL, setMl ] = useState([])
  const [ reserveData, setReservedDatat ] = useState([])
  const [ searchValue, setSearchValue ] = useState('')
  const [ isShowSearchResultTray, setIsShowSearchResultTray ] = useState(false)
  // modal related
  const [ currentModalData, setCurrentModalData ] = useState(null)
  const [
    isConsultationDetailModalOpen,
    setIsConsultationDetailModalOpen,
  ] = useState(false)

  const { data, loading, error } = {}
  const savedFilterData = {}

  const { me } = props
  const tkEnabled = checkTKFeatureEnabled(me)
  const crpEnabled = checkCRPFeatureEnabled(me)
  const showLicenseAndAvailibility = tkEnabled || crpEnabled

  const roleCheck = permission => {
    if (permission.isAdmin && permission.isPhysician) return 'Both'
    if (permission.isAdmin) return 'Admin'
    if (permission.isPhysician) return 'Provider'
    return 'Viewer'
  }

  useEffect(() => {
    if (props.data) {
      const tableData = []
      props.data.forEach(item => {
        if (item) {
          const row = {
            ...item,
            name: item.lastName.concat(item.firstName),
            team: item.teamName,
            availability: item.isDeactivated ? '--' : item.canManageAvailability.toString(),
            status: item.isDeactivated ? 'Deactivated' : item.licenseStatus,
          }
          if (tkEnabled || crpEnabled) {
            row.role = item.isDeactivated ? '--' : roleCheck(item.permissions)
          } else {
            row.isProvider = item.permissions.isPhysician ?  <FormattedMessage id="button.yes" />: <FormattedMessage id="button.no" />
            row.isAdmin = item.permissions.isAdmin ? <FormattedMessage id="button.yes" />: <FormattedMessage id="button.no" />
          }
          tableData.push(row)
        }
      })
      setMl(tableData)
      setReservedDatat(tableData)
    }
  }, [ crpEnabled, props.data, tkEnabled ])

  const savedSortData = {}
  const fetchAdminSessionsHandler = () => {
    //= ========Process filter data==========

    const sortOrder = savedSortData.order || undefined
    const sortParam = savedSortData.property || undefined
  }
  /**
   * Populating head cells based on admin or coach
   */

  const FilteredData = (keys, values) => {
    if (keys.length < 1) {
      setMl(reserveData)
      return
    }
    const allKeys = [ ...new Set(keys) ]


    const filtered = reserveData.filter(ele => {
      for (const key of allKeys) {
        if (!(values[key].includes(ele[key]))) {
          return false
        }
      }
      return true
    })
    const ids = mL.map(o => o.id)
    const filteredResults = filtered.filter(({ id }, index) => !ids.includes(id, index + 1))

    setMl(filtered)
  }
  useEffect(() => {
    if (showLicenseAndAvailibility) {
      setTableHeadCells(headCells)
    } else {
      setTableHeadCells(headCellsNoLicenseOrAvailability)
    }
  }, [ showLicenseAndAvailibility ])
  const filteredResult = () => mL.filter(
    person => (
      (person)
        .lastName.concat(person.firstName)
        .toLowerCase()
        .includes(searchValue.toLowerCase()) ||
        person
          .email
          .toLowerCase()
          .includes(searchValue.toLowerCase())
    )
  )
  useEffect(() => {
    const searchResult = filteredResult()
    setSearchResultList(searchResult)
  }, [ searchValue ])

  const handleClickAway = () => {
    setIsShowSearchResultTray(false)
  }
  const onSearchChangeHandler = e => {
    setSearchValue(e.target.value)
    if (e.target.value.length > 0) {
      setIsShowSearchResultTray(true)
    } if (e.target.value.length == 0) {
      setIsShowSearchResultTray(false)
      setSearchResultList([])
    }
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    const newOrder = isAsc ? 'desc' : 'asc'
    setOrder(newOrder)
    setOrderBy(property)
    // dispatch(sortParamActionsHandler({ property, order: newOrder }));
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    // dispatch(getAdminSessions(teamId, coachId, newPage, rowsPerPage));
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
    // dispatch(getAdminSessions(teamId, coachId, 0, parseInt(event.target.value, 10)));
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + 0) * rowsPerPage - mL.length) : 0

  const modalDataHandler = data => {
    setCurrentModalData({
      appointidofmodal: data.appointmentId,
      patientInfo: data.patient,
      memberId: data.physician.memberId,
    })
    setIsConsultationDetailModalOpen(true)
  }
  const consultationDetailModalOpenCloseHandler = () => {
    setIsConsultationDetailModalOpen(v => !v)
  }

  return (
    <Box sx={{ width: '100%' }} className={classes.containerStyle}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <Grid container style={{ display: 'flex', alignItems: 'center' }}>
          {((tkEnabled || crpEnabled) &&
          <Grid item xs={9}>
            <Filter
              memberFilters={memberFilters}
              fetchAdminSessionsHandler={fetchAdminSessionsHandler}
              filteredData={FilteredData}
            />
          </Grid>
          )}
          <Grid item xs={3} style={{ position: 'relative', width: '90%' }} >
            <InputBase
              className={classes.inputElement}
              id="search-bar"
              placeholder={intl.formatMessage({
                id: 'placeholder.search',
              })}
              classes={{
                input: classes.inputBase,
              }}
              value={searchValue}
              onChange={onSearchChangeHandler}
              autoComplete="off"
              onKeyPress={event => {
                if (event.key === 'Enter') {
                  event.preventDefault()
                  // onSearchClick();
                  event.target.blur()
                }
              }}
              startAdornment={
                <InputAdornment position="start">
                  {true && (
                    <IconButton
                      aria-label="toggle password visibility"
                    >
                      <SearchIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
            {isShowSearchResultTray && (
              <ClickAwayListener onClickAway={handleClickAway}>
                <Paper elevation={6} className={classes.searchResultTray}>
                  <List>
                    {searchResultList && searchResultList.length > 0 ? (
                      searchResultList.map((data, index) => (
                        <li
                          className={`${classes.list}`}
                          key={index}
                          onClick={e => {
                            props.onRowClick({
                              index: data.id,
                              data,
                            })
                          }}
                        >
                          <Typography
                            component="h4"
                            className={`${classes.searchResultTrayText} ${classes.searchResultTrayName}`}
                          >
                            {data.lastName},{data.firstName}
                          </Typography>
                        </li>
                      ))
                    ) : (
                      <li className={classes.list} style={{ justifyContent: 'center' }}>
                        <Typography
                          component="h4"
                        >
                          <FormattedMessage id="notfound.results" />
                        </Typography>
                      </li>
                    )}
                  </List>
                </Paper>
              </ClickAwayListener>
            )}
          </Grid>
        </Grid>
        {/* <Box style={{maxHeight:'70vh',overflow:'auto'}}> */}
        <TableContainer className={classes.tableContainer}>
          <Table stickyHeader aria-labelledby="Member table">
            <EnhancedTableHead
              from="adminSessions"
              columnData={tableHeadCells}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {!loading &&
                mL &&
                stableSort(mL, getComparator(order, orderBy))
                  // .slice(0 * rowsPerPage, 0 * rowsPerPage + rowsPerPage)
                  .map((row, index) => <Row onRowClick={props.onRowClick} row={row} key={index} index={index} showLicenseAndAvailibility={showLicenseAndAvailibility} />)}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={4} />
                </TableRow>
              )}
            </TableBody>
          </Table>
          {loading && (
            <Box style={{ width: '100%', height: '100%' }}>{<EcgLoader />}</Box>
          )}
        </TableContainer>
      </Paper>
    </Box>
  )
}



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NewTeamMembers/NewTeamMembers.jsx